import { render, staticRenderFns } from "./detail_header.vue?vue&type=template&id=3c727216&scoped=true"
import script from "./detail_header.vue?vue&type=script&lang=js"
export * from "./detail_header.vue?vue&type=script&lang=js"
import style0 from "./detail_header.vue?vue&type=style&index=0&id=3c727216&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c727216",
  null
  
)

export default component.exports